if (!customElements.get('aryveda-science')) {
  class AryvedaScience extends HTMLElement {
    constructor() {
      super();

      this.baseline = parseFloat(this.dataset.baseline) || 100;
      this.decayK = parseFloat(this.dataset.decayK) || 0.025;
      this.supportFactor = parseFloat(this.dataset.supportFactor) || 0.55;
      this.min = parseFloat(this.dataset.min) || 0;
      this.max = parseFloat(this.dataset.max) || 100;

      this.slider = this.querySelector('.ald-science__slider');
      this.toggle = this.querySelector('.ald-science__toggle-input');
      this.inputReadout = this.querySelector('.ald-science__readout--input .ald-science__readout-value');
      this.outputReadout = this.querySelector('.ald-science__readout--output .ald-science__readout-value');
      this.baselinePath = this.querySelector('.ald-science__curve--baseline');
      this.supportedPath = this.querySelector('.ald-science__curve--supported');
      this.guideline = this.querySelector('.ald-science__guideline');
      this.marker = this.querySelector('.ald-science__marker');
      this.chart = this.querySelector('.ald-science__chart');

      if (!this.slider || !this.chart) return;

      this.chartLeft = 44;
      this.chartRight = 380;
      this.chartTop = 12;
      this.chartBottom = 188;

      this.drawCurve(this.baselinePath, this.decayK);
      this.drawCurve(this.supportedPath, this.decayK * this.supportFactor);

      this.slider.addEventListener('input', this.update.bind(this));
      if (this.toggle) this.toggle.addEventListener('change', this.update.bind(this));

      this.update();
    }

    output(input, k) {
      return this.baseline * Math.exp(-k * input);
    }

    xToPixel(x) {
      const ratio = (x - this.min) / (this.max - this.min);
      return this.chartLeft + ratio * (this.chartRight - this.chartLeft);
    }

    yToPixel(y) {
      const ratio = Math.max(0, Math.min(1, y / this.baseline));
      return this.chartBottom - ratio * (this.chartBottom - this.chartTop);
    }

    drawCurve(pathEl, k) {
      if (!pathEl) return;

      const steps = 48;
      const points = [];

      for (let i = 0; i <= steps; i += 1) {
        const x = this.min + ((this.max - this.min) * i) / steps;
        const y = this.output(x, k);
        points.push(`${this.xToPixel(x)},${this.yToPixel(y)}`);
      }

      pathEl.setAttribute('d', `M${points.join(' L')}`);
    }

    update() {
      const inputValue = parseFloat(this.slider.value);
      const supportOn = this.toggle ? this.toggle.checked : false;
      const activeK = supportOn ? this.decayK * this.supportFactor : this.decayK;
      const outputValue = this.output(inputValue, activeK);

      if (this.inputReadout) this.inputReadout.textContent = Math.round(inputValue);
      if (this.outputReadout) this.outputReadout.textContent = Math.round(outputValue);

      const px = this.xToPixel(inputValue);
      const py = this.yToPixel(outputValue);

      if (this.guideline) {
        this.guideline.setAttribute('x1', px);
        this.guideline.setAttribute('x2', px);
      }

      if (this.marker) {
        this.marker.setAttribute('cx', px);
        this.marker.setAttribute('cy', py);
      }

      this.classList.toggle('ald-science--support-on', supportOn);
    }
  }

  customElements.define('aryveda-science', AryvedaScience);
}
